import React from 'react';
import { HotelRatingSquare } from '@lt/components';
import styled from 'styled-components';

export interface RatingBadgeProps {
  value: number | null;
  isMobile: boolean;
}

const RatingBadge = ({ isMobile, value }: RatingBadgeProps) => (
  <StyledHotelRating
    $align={isMobile ? 'right' : 'left'}
    showMeta={false}
    value={value}
    count={value}
  />
);

const StyledHotelRating = styled(HotelRatingSquare)<{
  $align: 'right' | 'left';
}>`
  position: absolute;
  z-index: 2;
  top: 10px;
  ${({ $align }) => `${$align}`}: 10px;
  stroke-width: 0 !important;
  cursor: pointer;
`;

export default RatingBadge;
